import { useReadEpisodePlayerBaseInfo } from '../../../hooks/use-read-episode-player-base-info';
import { getEpisodeOtt } from '../../../utils/get-episode-ott';
import { transformConcurrencyArbiterConfig } from '../../../../movie-player/transformers/transform-concurrency-arbiter-config';

export const useEpisodeConcurrencyArbiterConfig = (contentId: string) => {
    const episode = useReadEpisodePlayerBaseInfo(contentId);
    const ott = episode && getEpisodeOtt(episode);
    const concurrencyArbiterConfig = ott?.onlineStreams?.concurrencyArbiterConfig;

    return concurrencyArbiterConfig
        ? transformConcurrencyArbiterConfig(concurrencyArbiterConfig)
        : undefined;
};
